<div class="header">
    <div class="header-actions" *ngIf="!disabled">
    </div>
</div>

<div class="messages" *ngIf="!isLoading">
    <txp-message [type]="messageType.WARNING"
                 data-qa-label="NoPrepGroupWarningMessage"
                 *ngIf="dataSource.data.length === 0">
        {{ 'store.dynamicPrepTime.noPrepGroups' | translate }}
    </txp-message>
</div>

<div class="table-content">
    <table
        mat-table
        [dataSource]="dataSource"
        matSort
        matSortActive="name"
        matSortDirection="asc"
        matSortDisableClear
        [hidden]="isLoading">

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ 'store.dynamicPrepTime.groupName' | translate }}
            </th>
            <td mat-cell *matCellDef="let item">
                <a class="edit-link"
                    (click)="handleEdit(item.value)"
                    [attr.title]="'form.button.edit' | translate"
                    data-qa-label="EditLink">
                    {{ item.get('name').value }} [{{ item.get('items')?.value?.length || 0 }}]
                </a>
            </td>
        </ng-container>

        <ng-container matColumnDef="advancedNoticeHours">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ 'store.dynamicPrepTime.hoursInAdvance' | translate }}
            </th>
            <td mat-cell *matCellDef="let item" [formGroup]="item">
                <mat-form-field class="hours-in-advance">
                <input matInput
                        type="text"
                        formControlName="advancedNoticeHours"
                        data-qa-label="AdvancedNoticeHoursInput"
                        txpIntegersOnly
                        required>
                    <mat-error *ngIf="item.get('advancedNoticeHours').errors?.min">
                        {{ 'form.error.minValueShort' | translate }}
                    </mat-error>
                </mat-form-field>
            </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
            </th>
            <td mat-cell *matCellDef="let item">
                <ng-container *ngIf="!advancedNoticeReadOnly">
                    <txp-button data-qa-label="RemoveButton"
                                [style]="buttonStyle.ROWACTION"
                                icon="tce-icon-trash"
                                [attr.title]="'form.button.remove' | translate"
                                (click)="handleDelete(item.get('name').value, formArray)">
                    </txp-button>
                </ng-container>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>
    </table>

    <div class="actions" [hidden]="advancedNoticeReadOnly">
        <txp-button
            data-qa-label="AddAdvancedNoticeItemButton"
            [style]="buttonStyle.SECONDARY"
            (click)="addItem()">
            {{ 'store.dynamicPrepTime.addGroup' | translate }}
        </txp-button>
    </div>
</div>